import { paths } from "@/utils/paths-utils";
import { Heading } from "../base/heading";
import { HorizontalSpacer } from "../layout/horizontal-spacer";
import { VerticalContainer } from "../layout/vertical-container";
import { RegisterButton } from "../ui/register-button";
import { UserJourney } from "./types";

interface ChangeRecurrenceTypeLinkProps {
  userJourney: UserJourney;
}

export const ChangeRecurrenceTypeLink = ({ userJourney }: ChangeRecurrenceTypeLinkProps) => {
  switch (userJourney) {
    case UserJourney.Single:
      return (
        <ChangeRecurrenceTypeComponent
          heading="Meld deg inn i dag"
          ingress="For deg som ønsker avtalegiro og en lavere månedspris"
          title="Bli 3T-medlem"
          url={paths.bliMedlemPrefilled(UserJourney.Recurring)}
        />
      );
    case UserJourney.Recurring:
      return (
        <ChangeRecurrenceTypeComponent
          heading="Korttidsmedlemskap"
          ingress="For deg som kun ønsker å trene kun 1 måned uten bindingstid"
          title="Tren kun 1 måned"
          url={paths.bliMedlemPrefilled(UserJourney.Single, "1")}
        />
      );
    default:
      return (
        <ChangeRecurrenceTypeComponent
          heading="Korttidsmedlemskap"
          ingress="For deg som kun ønsker å trene kun 1 måned uten bindingstid"
          title="Tren kun 1 måned"
          url={paths.bliMedlemPrefilled(UserJourney.Single, "1")}
        />
      );
  }
};

interface ChangeRecurrenceTypeComponentProps {
  heading: string;
  ingress: string;
  title: string;
  url: string;
}
const ChangeRecurrenceTypeComponent = ({ heading, ingress, title, url }: ChangeRecurrenceTypeComponentProps) => (
  <VerticalContainer horizontalPlacement="center" width="full">
    <hr />
    <HorizontalSpacer size="large" />

    <Heading type="h2">{heading}</Heading>
    <HorizontalSpacer size="small" />

    <RegisterButton ingress={ingress} length={1} title={title} url={url} />
  </VerticalContainer>
);
